app.service('log', function ($global, front, pageConfig, cookie, localStorage, console, callback, logData, GMP) {
	var pageInfo = {};
	var GMPdata = {};
	var pageVisitCallback = null;
	let onEventCallbacks = [];
	var pageVisitInit = false;
	let logReady = false;

	function logCustomerVisit() {
		UA.push({ event: 'customerData', visitorId: logData.customerId(), visitId: logData.visitId() });
		logReady = true;
		for (var i = 0; i < onEventCallbacks.length; i++) {
			event(onEventCallbacks[i]);
		}
		onEventCallbacks = [];
	}
	function logCustomerVisitResponse(json) {
		if (json.facebookEventId) {
			UA.push({ event: 'facebookData', eventId: json.facebookEventId });
		}
	}
	function pageVisit() {
		$.ajax({
			url: '/visits-analytics.ltr',
			type: 'POST',
			cache: false,
			data: pageInfo,
			dataType: 'json',
			error: function () {
				logCustomerVisit();
			},
			success: function (json) {
				logCustomerVisit();
				logCustomerVisitResponse(json);
				callback.run('afterPageVisitLog', json);
				UA.sendFallbackData(sendFallbackData);
				if (pageVisitCallback) {
					pageVisitCallback();
				}
			}
		});
	}

	function sendFallbackData() {
		GMPdata = $.extend(GMPdata, {
			cd1: logData.customerId(),
			cd2: logData.visitId()
		});
		GMP.send(GMPdata);
		pageVisitInit = true;
	}

	function setFallbackData(params) {
		GMPdata = $.extend(GMPdata, params);
		if (pageVisitInit) {
			GMP.send(GMPdata);
		}
	}
	function successPageVisit() {
		setUserId(pageInfo.frontUserId);							//globalna, do posprzątania
		pageVisit();
	}
	function visitOnLoad(data, callbackFunction) {
		if (callbackFunction) {
			pageVisitCallback = callbackFunction;
		}
		visit(data);
	}
	function visit(data) {
		$.extend(true, pageInfo, {
			front: 'rwd',
			brakepoint: front.getBrakepoint(),
			keyword: localStorage.getItem('lastKeyword'),
			referrer: document.referrer,
			currentUrl: encodeURIComponent(document.location.href),
			productId: 0,
			productCode: '',
			productsGroupId: 0,
			nodeName: '',
			pageType: front.page(),
			t_page: 0,								//do ustalenia czy nadal jest potrzebne
			t_done: 0
		});
		$.extend(true, pageInfo, data);
		$.ajax({
			url: '/visitData.ltr',
			dataType: 'json',
			cache: false,
			success: function (json) {
				$.extend(true, pageInfo, json);
				callback.run('afterVisitLog', json);
				successPageVisit();
			}
		});
	}

	function eventOnLoad(data) {
		if (logReady || logData.customerId()) {
			logReady = true;
			event(data);
		} else {
			onEventCallbacks.push(data);
		}
	}
	function event(data, options) {
		if (typeof data == "undefined") {
			return false;
		}
		var params = {
			id: '',
			front: 'rwd',
			brakepoint: front.getBrakepoint(),
			f01: logData.customerId(),
			f02: logData.visitId()
		};

		var ajaxOptions = {
			type: 'POST',
			async: true,
			cache: false,
			url: '/shopEvent.ltr',
			data: $.extend(true, params, data)
		};

		$.extend(true, ajaxOptions, options);
		if (ajaxOptions.data.f03) {
			ajaxOptions.data.f03 = $('<div>' + ajaxOptions.data.f03 + '</div>').text()
		}
		if (ajaxOptions.data.id == 'remove_cart') {
			//nowe zdarzenie 'remove_cart'
			// f01 : USER_ID
			// f02 : VISIT_ID
			// f03 : Skąd usunięto produkt
			// f04 : PLU produktu dodanego do koszyka 
			// f05 : Kategoria produktu/towaru, usługi, gwarancji 
			// f06 : PLU produktu , do którego zostalo dodane akcesorium/ubezpieczenie/usługa
			// f07 : Szczegółowe miejsce dodania, placement
			// f08 : Szczegółowe miejsce dodania
			// f09 : Stan produktu
			// f10 : Typ płatności
			// f11 :  nr zestawu
			if (!ajaxOptions.data.f11) {
				ajaxOptions.data.f11 = '';
			}
		} else if (ajaxOptions.data.id == 'to_cart') {
			//nowe zdarzenie 'to_cart'
			// f01 : USER_ID
			// f02 : VISIT_ID
			// f03 : Skąd dodano produkt
			// product_card - Karta produktu
			// product_list - Listing
			// comparison 	- Dodanie do koszyka z porównania
			// cart_step_0 	- K0 (akcesoria)
			// cart_step_1 	- K1 (ubezpieczenia, akcesoria/towary, usługi)
			// cms 			- Dodanie ze stron promocyjnych
			// kme 			- Dodanie produktów do koszyka z KME – konto moje euro
			// articles 	- Aktykuły
			// f04 : PLU produktu dodanego do koszyka 
			// f05 : Kategoria produktu/towaru, usługi, gwarancji 
			// product 		- produkt
			// service 		- usługa
			// warranty 	- ubezpieczenie
			// subscription 	- subskrypcja
			// gift_card 	- Karta podarunkowa
			// akc 			- akcesorium
			// f06 : PLU produktu , do którego zostalo dodane akcesorium/ubezpieczenie/usługa
			// f07 : Szczegółowe miejsce dodania, placement
			// accessory_card 	- Dodanie produktu akcesoryjnego z karty produktu dla wersji
			// warranty_details - Szczegóły ubezpieczenia
			// warranty_box 	- Box ochrony ubezpieczeniowej
			// services_details - Szczegóły usług
			// product_details 	- Szczegóły produktu na KP
			// others_watched 	- Inni oglądali również
			// recently_watched - Ostatnio oglądane
			// leaf				- Listing, ranking ,cms
			// watched_products - Oglądane produkty
			// services_box 	- Box usług
			// f08 : Szczegółowe miejsce dodania
			// fancybox - Warstwa
			// button - Przycisk
			// f09 : Stan produktu
			// new 	  - Towar nowy
			// outlet - Outlet
			// f10 : Typ płatności
			// installment - Raty
			// cash - Gotówka
			// subscription - Płatność miesięczna
			// f12 : ciasteczka - zrezygnowano
			// f23 : breakpoint (desktop, mobile, tablet)
			// f24 : 'SI/TO/EK'
			if (!ajaxOptions.data.f09) {
				ajaxOptions.data.f09 = '';
			}

		}
		if (ajaxOptions.data.id == 'cart_step') {
			// nowe zdarzenie 'cart_step'
			// f03 : pełny link
			ajaxOptions.data.f10 = cookie.get('testAB');
			ajaxOptions.data.f03 = document.location.pathname;
			if (!ajaxOptions.data.f14) {
				ajaxOptions.data.f14 = pageInfo && pageInfo.frontUserId ? pageInfo.frontUserId : '';
			}
		}
		if (ajaxOptions.data.id == 'click_promotion') {
			// nowe zdarzenie 'click_promotion'
			// 	f01: user_id,
			// 	f02: visit_id,
			// 	f03: document.location.pathname, // adres przeglądarki w momencie kliknięcia
			ajaxOptions.data.f03 = document.location.pathname;
			// 	f04: link do promocji dostarczony na widoku,
			// 	f05: nazwa promocji dostarczona na widoku, analogicznie jak promotion_name z GA
			// 	f06: typ strony (koszyk: 'cart_step_1' lub strony promocyjne: 'cms')
			// 	f07: odpowiednik creative_name w GA
			// 	f23: rodzaj ekranu, //uzupełnione poniżej
			// 	f24: rodzaj frontu, //uzupełnione poniżej
			// 	FRONT:si_rwd/si //uzupełnione poniżej
		}

		if (['cart_step', 'to_cart', 'remove_cart', 'click_promotion', 'app_rating'].includes(ajaxOptions.data.id)) {
			// części wspólne dla cart_step, to_cart, remove_cart, click_promotion
			delete ajaxOptions.data.brakepoint;
			ajaxOptions.data.technology = 'SI_RWD'; // istniejąca już kolumna w shopeventlogu : EventSource - niech parametr ten przyjmuje analogiczne wartości jak obecnie: HEADLESS/SI/SI_RWD zamiast monolith/headless
			var viewportWidth = window.innerWidth;
			ajaxOptions.data.f23 = viewportWidth >= 1024 ? 'desktop' : viewportWidth < 1024 && viewportWidth > 719 ? 'tablet' : 'mobile';
			ajaxOptions.data.f24 = pageConfig.getData('operator').isLogged ? 'TO' : 'SI';
		}

		if(ajaxOptions.data.id == 'agreements-form') {
			//poniższe parametry na potrzeby przesłania eventu ze skryptów Euro (CMS lub komunikaty)
			if (ajaxOptions.data.f07 == '') { // KME ID - jeśli puste, wtedy całkiem usuwamy
				delete ajaxOptions.data.f07;
			}
			if (ajaxOptions.data.f08 == '') { // adres email zalogowanego użytkownika - jeśli puste, wtedy całkiem usuwamy
				delete ajaxOptions.data.f08;
			}
			if (ajaxOptions.data.f09 == '') { // adres email z formularza - jeśli puste, wtedy całkiem usuwamy
				delete ajaxOptions.data.f09;
			}
		}

		// Rozszerzenie o zawartość ciasteczka testAb 
		if (['remove_cart', 'cart_step', 'to_cart'].includes(ajaxOptions.data.id)) {
			ajaxOptions.data.f30 = logData.getTestAb();
		}

		if (params.id !== '') {
			console.log('shopEvent', JSON.parse(JSON.stringify(ajaxOptions.data)));
			let fData = new FormData();
			for (var key in ajaxOptions.data) {
				if (typeof ajaxOptions.data[key] !== "function") {
					fData.append(key, ajaxOptions.data[key]);
				}
			}
			navigator.sendBeacon(ajaxOptions.url, fData);
		}
	}
	

	$global('logEvent', eventOnLoad);
	$global('logEventCartStep', eventOnLoad);
	$global('setFallbackData', setFallbackData);
	return {
		visit: visitOnLoad,
		event: eventOnLoad
	};
});
